export default "__VITE_ASSET__$fp5kBd5__"